import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { adminMe } from "../lib/adminApi";

// Roles allowed to use the internal RFP & Requirements Analysis (SmartBid) flow.
const ALLOWED_ROLES = ["admin", "consultant", "demo"];

/**
 * Route guard for the SmartBid RFP flow. The flow is no longer public — only a
 * logged-in user with an allowed role may reach it. Non-logged-in / disallowed
 * users are redirected to the login portal.
 */
export default function RequireWorkspaceAuth() {
  const navigate = useNavigate();
  const [state, setState] = useState("checking"); // checking | allowed | denied

  useEffect(() => {
    let active = true;
    const check = async () => {
      try {
        const u = await adminMe();
        if (!active) return;
        const role = (u?.role || "").toLowerCase();
        if (u && ALLOWED_ROLES.includes(role)) {
          setState("allowed");
        } else {
          setState("denied");
          navigate("/transformation", { replace: true });
        }
      } catch {
        if (!active) return;
        setState("denied");
        navigate("/transformation", { replace: true });
      }
    };
    check();
    return () => { active = false; };
  }, [navigate]);

  if (state === "checking") {
    return (
      <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center">
        <p className="text-sm text-[#6B7280]">Loading…</p>
      </div>
    );
  }
  if (state === "denied") return null;
  return <Outlet />;
}
